import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Home from './components/Home';
import Host from './components/Host';
import RoleSelection from './components/RoleSelection';
import Participant from './components/Participant';
import Judge from './components/Judge';
import LinkInvitation from './components/LinkInvitation';
import SubmittedMovies from './components/SubmittedMovies';
import Winner from './components/Winner';
import Terminal from './components/Terminal';
import logo from './logo.svg';
import './App.css';
// Create a new NavBar component
function NavBar() {
  const navigate = useNavigate();
  
  return (
    <nav className="navbar">
      <button className="nav-logo-button" onClick={() => navigate('/')}>
        <img src={logo} alt="Home" className="nav-logo" />
      </button>
    </nav>
  );
}

function App() {

  return (
    <Router>
      <div className="App">
        <NavBar />
        <div className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/host" element={<Host />} />
            <Route path="/role-selection" element={<RoleSelection />} />
            <Route path="/participant" element={<Participant />} />
            <Route path="/judge" element={<Judge />} />
            <Route path="/link-invitation" element={<LinkInvitation />} />
            <Route path="/submitted-movies" element={<SubmittedMovies />} />
            <Route path="/winner" element={<Winner />} />
            <Route path="/terminal" element={<Terminal />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
